import Message from "../../message";
import {useMainStore} from "@/store";
import {cleanupStaleNotifications} from "@/services/notificationCleanup";

export default class ApplicationRejected extends Message
{
    handle()
    {
        useMainStore().REMOVE_GUILD_APPLICATION(this.message.user_id);
        cleanupStaleNotifications();
    }
}
